import { isPlatformBrowser } from '@angular/common';
import { inject, PLATFORM_ID } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import {
  CreateCompanyRequestBillingCycle,
  CreateCompanyRequestPlanKey,
} from '@core/api/workspace/models';
import { TokenStorageService } from '@core/services/token-storage.service';

function isBrowser(): boolean {
  return isPlatformBrowser(inject(PLATFORM_ID));
}

export const authGuard: CanActivateFn = () => {
  if (!isBrowser()) {
    return true;
  }

  const tokenStorage = inject(TokenStorageService);
  const router = inject(Router);

  if (tokenStorage.isAuthenticated()) {
    return true;
  }

  return router.createUrlTree(['/login']);
};

export const workspaceSessionGuard: CanActivateFn = () => {
  if (!isBrowser()) {
    return true;
  }

  const tokenStorage = inject(TokenStorageService);
  const router = inject(Router);

  if (!tokenStorage.isAuthenticated()) {
    return true;
  }

  if (tokenStorage.hasWorkspaceSession()) {
    return true;
  }

  const accessCount = tokenStorage.getWorkspaceAccessCount();

  if (accessCount === 0) {
    return router.createUrlTree(['/create-company'], {
      queryParams: {
        planKey: CreateCompanyRequestPlanKey.free,
        billingCycle: CreateCompanyRequestBillingCycle.MONTHLY,
      },
    });
  }

  return router.createUrlTree(['/select-workspace']);
};
